import type { ActivationTask } from '@cobliteam/api-lib/src/__generated__/graphql';
import { AdvancedSettingsActivationTasks, BasicSettingsActivationTasks, type Category, type Task } from '../ActivationTasksCommon';

export const getOnboardingTaskConfiguration = (activationTasks: ActivationTask[]) => {
  const basicTasks = activationTasks.map((activationTask) => {
    const basicTask = BasicSettingsActivationTasks.find((step) => step.name === activationTask.name);

    return {
      ...activationTask,
      ...basicTask,
    } as Task;
  });

  const advancedTasks = activationTasks.map((activationTask) => {
    const advancedTask = AdvancedSettingsActivationTasks.find((step) => step.name === activationTask.name);

    return {
      ...activationTask,
      ...advancedTask,
    } as Task;
  });

  const basicTaskCategory: Category = {
    i18nKey: 'basic_settings',
    tasks: basicTasks,
  };

  const advancedTaskCategory: Category = {
    i18nKey: 'advanced_settings',
    tasks: advancedTasks,
  };

  return [basicTaskCategory, advancedTaskCategory];
};
